/* ============================================================
   FLOWERTRAIL — Zoom Guard v2
   Pinch/zoom was laggy because EVERY zoom frame re-rasterizes:
   (a) the fixed starfield — 3 tiled, infinitely-animating layers,
   (b) 200+ backdrop-filter glass surfaces sampling that moving
       backdrop, (c) playing videos repainting under it all.
   v1 only paused animations — not enough. v2 goes nuclear for the
   duration of the gesture: html.ft-zooming now REMOVES the
   starfield + meteor layers (page ground is already black), kills
   every backdrop-filter (blur of flat black looks identical), and
   pauses <video> playback. The compositor is left zooming a
   static, filter-free page — pure GPU, butter on both platforms.

   Detection: 2-finger touch, iOS gesture events, visualViewport
   scale, ctrl+wheel (trackpad pinch), ctrl +/-/0, DPR-change.
   The freeze holds while visually zoomed-in (scale > 1.02) and a
   watchdog guarantees release — the class can never get stuck
   (v1 could strand it, which also hid the cursor: fixed).
   Emits ft:zoom-start / ft:zoom-end for the KX engine + meteors.
   ============================================================ */
(function () {
  'use strict';
  var html = document.documentElement;
  var timer = null;
  var watchdog = null;
  var active = false;
  var lastActivity = 0;
  var SETTLE = 400;
  var pausedVideos = [];

  function zoomedIn() {
    return !!(window.visualViewport && window.visualViewport.scale > 1.02);
  }

  function pauseVideos() {
    pausedVideos = [];
    try {
      document.querySelectorAll('video').forEach(function (v) {
        if (!v.paused && !v.ended) {
          pausedVideos.push(v);
          v.pause();
        }
      });
    } catch (e) {}
  }

  function resumeVideos() {
    pausedVideos.forEach(function (v) {
      try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
    });
    pausedVideos = [];
  }

  function begin() {
    lastActivity = Date.now();
    if (!active) {
      active = true;
      html.classList.add('ft-zooming');
      pauseVideos();
      try { window.dispatchEvent(new CustomEvent('ft:zoom-start')); } catch (e) {}
      /* watchdog: even if no further event ever fires, re-check every
         400ms and release once the viewport is settled — the freeze
         class can never be stranded */
      if (!watchdog) {
        watchdog = setInterval(function () {
          if (!active) { clearInterval(watchdog); watchdog = null; return; }
          if (!zoomedIn() && Date.now() - lastActivity > SETTLE) end();
        }, 400);
      }
    }
    bump();
  }

  function bump() {
    if (timer) { clearTimeout(timer); timer = null; }
    if (zoomedIn()) return; /* hold while pinched in — watchdog re-arms release */
    timer = setTimeout(end, SETTLE);
  }

  function end() {
    if (timer) { clearTimeout(timer); timer = null; }
    if (zoomedIn()) return; /* never release while actually zoomed */
    active = false;
    if (watchdog) { clearInterval(watchdog); watchdog = null; }
    html.classList.remove('ft-zooming');
    resumeVideos();
    try { window.dispatchEvent(new CustomEvent('ft:zoom-end')); } catch (e) {}
  }

  /* desktop: trackpad pinch / ctrl+wheel */
  window.addEventListener('wheel', function (e) {
    if (e.ctrlKey) begin();
  }, { passive: true, capture: true });

  /* desktop: keyboard zoom */
  window.addEventListener('keydown', function (e) {
    if ((e.ctrlKey || e.metaKey) &&
        (e.key === '+' || e.key === '-' || e.key === '=' || e.key === '0')) begin();
  }, { passive: true, capture: true });

  /* iOS Safari pinch */
  window.addEventListener('gesturestart', begin, { passive: true });
  window.addEventListener('gesturechange', begin, { passive: true });

  /* generic mobile pinch (Android fires no gesture events) */
  window.addEventListener('touchstart', function (e) {
    if (e.touches && e.touches.length > 1) begin();
  }, { passive: true, capture: true });
  window.addEventListener('touchmove', function (e) {
    if (e.touches && e.touches.length > 1) begin();
  }, { passive: true, capture: true });

  /* visual viewport scale tracking — catches pinch momentum and
     re-arms the release when the user zooms back out */
  if (window.visualViewport) {
    var vv = window.visualViewport;
    var lastScale = vv.scale;
    vv.addEventListener('resize', function () {
      if (Math.abs(vv.scale - lastScale) > 0.001) {
        lastScale = vv.scale;
        begin();
      } else if (active && !zoomedIn()) {
        bump();
      }
    }, { passive: true });
  }

  /* browser-menu / keyboard zoom changes devicePixelRatio */
  var lastDPR = window.devicePixelRatio;
  window.addEventListener('resize', function () {
    if (window.devicePixelRatio !== lastDPR) {
      lastDPR = window.devicePixelRatio;
      begin();
    }
  }, { passive: true });
})();
